import { Button } from '@/components/shadcn/button'
import { SupportPanelState } from '@/layouts/CatalogLayout'
import { IconCloseOutline } from '@icons/IconCloseOutline'
import clsx from 'clsx'
import { motion } from 'motion/react'
import { PAGE_HEADER_HEIGHT, SUPPORT_PANEL_WIDTH } from '../config'

export type SupportPanelProps = SupportPanelState & {
  children: React.ReactNode
}

const renderTitle = (key = '') => {
  switch (key) {
    case 'data-assets':
      return 'Data assets'
    case 'data-templates':
      return 'Templates'
    case 'glossary':
      return 'Glossary'
    case 'faq':
      return 'FAQ'
    default:
      return 'Support'
  }
}

function SupportPanelHeader({ supportPanelKey, children }: { supportPanelKey?: string; children: React.ReactNode }) {
  return (
    <div
      style={{ height: PAGE_HEADER_HEIGHT }}
      className="flex w-full items-center justify-between gap-10 border-x border-b bg-offwhite px-5 py-2"
    >
      <h6 className="whitespace-nowrap text-xl font-bold backdrop-blur">{renderTitle(supportPanelKey)}</h6>
      {children}
    </div>
  )
}

export function SupportPanelV2({ supportPanelView, setSupportPanelView, children }: SupportPanelProps) {
  return (
    <motion.div
      layout
      className={clsx('flex h-full flex-col overflow-hidden bg-background', { hidden: !supportPanelView })}
    >
      <SupportPanelHeader supportPanelKey={supportPanelView?.key}>
        <Button
          variant="ghost"
          className="size-8 hover:bg-offwhite hover:text-foreground"
          size="icon"
          onClick={() => setSupportPanelView(undefined)}
        >
          <IconCloseOutline className="size-3" />
        </Button>
      </SupportPanelHeader>
      <motion.div layout className="flex-1">
        <motion.div layout style={{ width: SUPPORT_PANEL_WIDTH }} className="px-5">
          {children}
        </motion.div>
      </motion.div>
    </motion.div>
  )
}
